// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".h-12px[data-v-2c7f190e]{height:12px}.h-18px[data-v-2c7f190e]{height:18px}.h-20px[data-v-2c7f190e]{height:20px}.h-26px[data-v-2c7f190e]{height:26px}.h-30px[data-v-2c7f190e]{height:30px}.h-36px[data-v-2c7f190e]{height:36px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
